import { useToggleV2, useWindowSize } from 'hooks';
import { useMemo } from 'react';

import { MAX_BREAKPOINTS } from 'styles';
import { quickContext } from 'utils/react';

export const SIDE_BAR_MOBILE_PX = MAX_BREAKPOINTS.MID_TABLET;

interface AppWrapperContext {
  isSideBarOpen: boolean;
  toggleSideBar: () => void;
  showMobileSidebar: boolean;
  showIconOnly: boolean;
  escapeDrawer?: () => void;
}

export const { useAppWrapper, AppWrapperProvider, withAppWrapperContext } = quickContext(
  'appWrapper',
  () => {
    const { width } = useWindowSize();

    const isDesktop = width > SIDE_BAR_MOBILE_PX;

    const [isSideBarOpen, { toggle: toggleSideBar }] = useToggleV2(isDesktop);

    const showMobileSidebar = !isDesktop;

    return {
      data: useMemo(
        () => ({
          isSideBarOpen,
          toggleSideBar,
          showMobileSidebar,
          showIconOnly: !isSideBarOpen && isDesktop,
          escapeDrawer: isSideBarOpen && showMobileSidebar ? toggleSideBar : undefined,
        }),
        [isSideBarOpen, toggleSideBar, isDesktop, showMobileSidebar],
      ) as AppWrapperContext,
    };
  },
);
